var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-header flex-box"},[_c('div',{staticClass:"flex-box g-header-left"},[_c('i',{staticClass:"iconfont",class:_vm.icon}),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || _vm.$route.name))])]),_vm._v(" "),_vm._t("rightBtn")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afece0be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = j0zN
// module chunks = 88